import { Component, Input, OnInit } from '@angular/core';
import { StateAmlCtfSanctions } from '../../../models/aml.model';
import { MlroModalComponent } from '../../modals/mlro-modal/mlro-modal.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { RegistrationApplicationForm } from '../../../../features/application/registration/models/registration-application-form.model';
import { ApplicationModel } from '../../../models/application.model';

@Component({
    selector: 'app-aml-section',
    templateUrl: './aml-section.component.html',
    styleUrls: ['./aml-section.component.scss'],
    standalone: false
})
export class AmlSectionComponent implements OnInit {
  @Input() aml!: StateAmlCtfSanctions;
  @Input() application!: ApplicationModel<RegistrationApplicationForm>;

  fullName!: string;

  constructor(private modal: NzModalService) {

  }

  ngOnInit(): void {
    this.fullName = this.setFullName();
  }

  showMlroModal() {
    this.modal.create({
      nzContent: MlroModalComponent,
      nzData: {mlro: this.aml, application: this.application},
      nzFooter: null
    });
  }

  private setFullName(): string {
    if (this.aml.mlroId && this.application) {
      let individual = this.application!.form!.individuals!.find(ind => ind.id === this.aml.mlroId);
      return individual ? `${individual.firstName} ${individual.middleName} ${individual.lastName}` : '';
    }
    else {
      return `${this.aml.officerFirstName} ${this.aml.officerMiddleName} ${this.aml.officerLastName}`;
    }
  }
}